export default __webpack_public_path__ + "static/media/4535.aa51b968.png";